import {
  number,
  shape,
} from 'prop-types';

export default shape({
  currentFate: number.isRequired,
});